<template>
<m-setup-wrapper @startGame="startGame">

  <m-game-settings v-model="gameSettings" :enabled-settings="{ pairAmount: true, cardsToTurn: true, theme: true }"></m-game-settings>

</m-setup-wrapper>
</template>

<script>
import SetupBase from '@/components/setup/SetupBase.vue';

export default {
  extends: SetupBase,
  methods: {
    async startGame() {
      const gameSettings = Object.assign({}, this.gameSettings, {
        gameMode: 'stopwatch',
      });
      const cards = this.$utils.generateLayout(gameSettings);
      await this.$store.dispatch('setupGame', {
        gameSettings,
        cards,
      });
    },
  },

  async created() {
    this.$wait.start('setup')
    await this.$store.dispatch('setupLocalLobby');
    this.$set(this, 'gameSettings', this.$store.state.lobby.gameSettings)
    this.$wait.end('setup')
  },
};
</script>

<style lang="scss" scoped>
</style>
